<section class="critical-error-shell">
  <article class="critical-error-card">

    <div class="critical-error-icon-area" aria-hidden="true">
      @switch (errorContent.iconType) {
        @case ('connection') {
          <svg class="error-svg" viewBox="0 0 64 64" role="presentation">
            <path d="M8 25C20.5 14 43.5 14 56 25" />
            <path d="M17 34C25 27 39 27 47 34" />
            <path d="M26 43C28.7 40.3 35.3 40.3 38 43" />
            <circle cx="32" cy="52" r="2.5" class="svg-fill" />
            <line x1="11" y1="11" x2="53" y2="53" class="svg-slash" />
          </svg>
        }
        @case ('not-found') {
          <svg class="error-svg" viewBox="0 0 64 64" role="presentation">
            <circle cx="28" cy="28" r="16" />
            <line x1="40" y1="40" x2="54" y2="54" />
            <line x1="22" y1="28" x2="34" y2="28" />
          </svg>
        }
        @case ('unauthorized') {
          <svg class="error-svg error-svg--unauthorized" viewBox="0 0 64 64" role="presentation">
            <rect x="16" y="28" width="32" height="24" rx="6" />
            <path d="M23 28V21C23 16 27 12 32 12C37 12 41 16 41 21V28" />
            <circle cx="32" cy="39" r="2.8" class="svg-fill" />
            <line x1="32" y1="41.8" x2="32" y2="46.5" />
            <path d="M45 17 L52 24" class="svg-slash-light" />
            <path d="M52 17 L45 24" class="svg-slash-light" />
          </svg>
        }
        @case ('forbidden') {
          <svg class="error-svg error-svg--forbidden" viewBox="0 0 64 64" role="presentation">
            <path d="M32 10L50 17V29C50 40.2 42.6 49.9 32 53C21.4 49.9 14 40.2 14 29V17L32 10Z" />
            <circle cx="32" cy="31" r="9" />
            <line x1="27" y1="31" x2="37" y2="31" class="svg-slash" />
          </svg>
        }
        @case ('server') {
          <svg class="error-svg error-svg--server" viewBox="0 0 64 64" role="presentation">
            <rect class="svg-rack" x="10" y="10" width="34" height="11" rx="4" />
            <rect class="svg-rack" x="10" y="26.5" width="34" height="11" rx="4" />
            <rect class="svg-rack" x="10" y="43" width="34" height="11" rx="4" />

            <line x1="17" y1="15.5" x2="28" y2="15.5" />
            <line x1="17" y1="32" x2="28" y2="32" />
            <line x1="17" y1="48.5" x2="28" y2="48.5" />

            <circle cx="36.5" cy="15.5" r="1.7" class="svg-fill" />
            <circle cx="36.5" cy="32" r="1.7" class="svg-fill" />
            <circle cx="36.5" cy="48.5" r="1.7" class="svg-fill" />

            <path d="M48.5 35.8 L59 54 H38 Z" class="svg-alert-triangle" />
            <line x1="48.5" y1="42.4" x2="48.5" y2="47.1" class="svg-alert-mark" />
            <circle cx="48.5" cy="49.6" r="1.1" class="svg-alert-dot" />
          </svg>
        }
        @default {
          <svg class="error-svg" viewBox="0 0 64 64" role="presentation">
            <path d="M32 10 L56 54 H8 Z" />
            <line x1="32" y1="26" x2="32" y2="41" />
            <circle cx="32" cy="47.5" r="2" class="svg-fill" />
          </svg>
        }
      }
    </div>

    <div class="critical-error-body">
      @if (errorCode !== '0') {
        <span class="critical-error-chip">Erro {{ errorCode }}</span>
      }
      <h1>{{ errorContent.title }}</h1>
      <p class="critical-error-description">{{ backendMessage ?? errorContent.description }}</p>

      @if (!backendMessage) {
        <div class="critical-error-hint">
          <svg viewBox="0 0 16 16" aria-hidden="true" class="hint-icon">
            <circle cx="8" cy="8" r="6.5" />
            <line x1="8" y1="7.5" x2="8" y2="11" />
            <circle cx="8" cy="5.5" r="0.8" class="hint-dot" />
          </svg>
          <p>{{ errorContent.helper }}</p>
        </div>
      }


    </div>

  </article>

  <div class="critical-error-footer">
    <button
      ejs-button
      cssClass="e-primary critical-error-action"
      (click)="reloadPreviousPage()"
      [disabled]="isReloading">
      {{ isReloading ? 'Atualizando...' : 'Atualizar página' }}
    </button>
  </div>
</section>
